module.exports = __webpack_public_path__ + "src/assets/animations/strawberry.txt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/strawberry.txt
// module id = ./src/assets/animations/strawberry.txt
// module chunks = 0